<section class="mat-typography mat-body mat-app-background">

  <h2>{{ content?.myProfileTitle}}</h2>
  <p>{{ content?.myProfileContent}}</p>
  <p>{{ content?.myProfileContentInfo}}</p>

  <br/>

  @if (unifiedLoginSettingsUrl) {
    <div>
      Multi-factor Authentication (MFA): <a [href]="unifiedLoginSettingsUrl" target="_blank">Update your settings</a>
    </div>
  }

  <br/>

  <div class="personal-info">
    <h2>{{ content?.myProfileInfoTitle}}</h2>
  </div>


  <form [formGroup]="form">
    @if (content.showFirstName) {
      <mat-form-field [appearance]="isEditMode ? 'fill' : 'outline'">
        <mat-label>First Name</mat-label>
        <input matInput type="text" formControlName="firstName" [readonly]='true'>
      </mat-form-field>
    }

    @if (content.showLastName) {
      <mat-form-field [appearance]="isEditMode ? 'fill' : 'outline'">
        <mat-label>Last Name</mat-label>
        <input matInput type="text" formControlName="lastName" [readonly]='true'>
      </mat-form-field>
    }

    @if (content.showAddress) {
      <mat-form-field [appearance]="isEditMode ? 'fill' : 'outline'">
        <mat-label>Address Line 1</mat-label>
        <input matInput type="text" formControlName="addressLine1" [readonly]='true'>
      </mat-form-field>
    }

    @if (content.showZipCounty) {
      <mat-form-field [appearance]="isEditMode ? 'fill' : 'outline'">
        <mat-label>Zip Code</mat-label>
        <input matInput type="text" formControlName="zipCode" [readonly]='true'>
      </mat-form-field>
    }

    @if (content.showAddress) {
      <mat-form-field [appearance]="isEditMode ? 'fill' : 'outline'">
        <mat-label>City</mat-label>
        <input matInput type="text" formControlName="city" [readonly]='true'>
      </mat-form-field>
    }

    @if (content.showAddress) {
      <mat-form-field [appearance]="isEditMode ? 'fill' : 'outline'">
        <mat-label>State</mat-label>
        <input matInput type="text" formControlName="state" [readonly]='true'>
      </mat-form-field>
    }

    @if (content.showDob) {
      <mat-form-field [appearance]="isEditMode ? 'fill' : 'outline'">
        <mat-label>Date of Birth</mat-label>
        <input matInput type="text" formControlName="dateOfBirth" [readonly]='true'>
      </mat-form-field>
    }

    @if (content.showGender) {
      <mat-form-field [appearance]="isEditMode ? 'fill' : 'outline'">
        <mat-label>Gender</mat-label>
        <input matInput type="text" formControlName="gender" [readonly]='true'>
      </mat-form-field>
    }

    @if (content.showEmail) {
      <mat-form-field [appearance]="isEditMode ? 'fill' : 'outline'">
        <mat-label>Email Address</mat-label>
        <input matInput type="text" formControlName="emailAddress" [readonly]='true'>
      </mat-form-field>
    }

    @if (content.showPhoneNumber) {
      <mat-form-field [appearance]="isEditMode ? 'fill' : 'outline'">
        <mat-label>Phone Number</mat-label>
        <input matInput type="text" formControlName="phoneNumber" [readonly]='true'>
      </mat-form-field>
    }

    @if (content.showPassword) {
      <mat-form-field [appearance]="isEditMode ? 'fill' : 'outline'">
        <mat-label>Password</mat-label>
        <input matInput type="text" formControlName="password" [readonly]='true'>
      </mat-form-field>
    }
  </form>

  @if (isProducerRole) {
    <app-agent-information [content]="content"></app-agent-information>
  }

</section>
